import { ActionType } from "src/store/dataService/actions/utils/actionCreator";
import { Appointment } from "Types/api/Appointment";
import { pollingSuccess } from "src/store/actions/poller";
import { postTestDriveSuccess } from "src/store/actions/testDrive";
import { getDealSuccess } from "src/store/actions/deal";

export type TestDriveState = Appointment | null;

type HandledActions =
    | ActionType<typeof pollingSuccess>
    | ActionType<typeof postTestDriveSuccess>
    | ActionType<typeof getDealSuccess>;

function reducer(state: TestDriveState = null, action: HandledActions): TestDriveState {
    switch (action.type) {
        case getDealSuccess.type:
        case pollingSuccess.type:
            if (action.payload.deal.appointments?.test_drive) {
                return {
                    date: action.payload.deal.appointments.test_drive.date,
                    time: action.payload.deal.appointments.test_drive.time,
                };
            }
            return state;

        case postTestDriveSuccess.type:
            return { date: action.payload.appointment.date, time: action.payload.appointment.time };

        default:
            return state;
    }
}

export default reducer;
